// services/avatarService.js - Web version
import supabase from './supabase';
import { genConfig } from 'react-nice-avatar';

/**
 * Generate random avatar configuration
 */
export const generateRandomAvatar = () => {
  return genConfig();
};

/**
 * Generate avatar with specific attributes
 */
export const generateCustomAvatar = (customOptions = {}) => {
  const baseConfig = genConfig();
  return { ...baseConfig, ...customOptions };
};

/**
 * Save avatar to user profile
 */
export const saveAvatarConfig = async (config) => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const { data, error } = await supabase
    .from('users')
    .update({ avatar_config: config })
    .eq('id', user.id)
    .select()
    .single();

  if (error) throw error;
  return data;
};

/**
 * Get user's avatar config
 */
export const getUserAvatarConfig = async (userId = null) => {
  let targetUserId = userId;

  if (!targetUserId) {
    const { data: { user } } = await supabase.auth.getUser();
    targetUserId = user?.id;
  }

  if (!targetUserId) return genConfig();

  try {
    const { data, error } = await supabase
      .from('users')
      .select('avatar_config')
      .eq('id', targetUserId)
      .single();

    if (error || !data?.avatar_config) {
      // Return default config if none exists
      return genConfig();
    }

    return data.avatar_config;
  } catch (error) {
    console.error('Error fetching avatar config:', error);
    return genConfig();
  }
};

// Preset options for quick customization
export const AVATAR_PRESETS = {
  hairStyles: ['normal', 'thick', 'mohawk', 'womanLong', 'womanShort'],
  hairColors: ['#000', '#fff', '#77311D', '#FC909F', '#D2EFF3'],
  shirtStyles: ['hoody', 'short', 'polo'],
  shirtColors: ['#77311D', '#F4D150', '#D2EFF3', '#FC909F'],
  bgColors: ['#506AF4', '#77311D', '#F4D150', '#D2EFF3'],
};
